import { useContext } from 'react';
import { FormControlLabel, Grid, Checkbox, TextField, MenuItem } from '@material-ui/core';
import { applicationContext } from 'helpers/services';
import { IBulkEditRequest } from '../BulkEditContext';
import { TypeInfo } from 'helpers/enums';
import { Alert, AlertTitle } from '@material-ui/lab';


interface IProps {
    request: IBulkEditRequest
    updateRequest: (newRequest: IBulkEditRequest) => void
}

let TicketTypology = ({ request, updateRequest }: IProps) => {
    let { ticketTypes, issueServiceTypes } = useContext(applicationContext);


    return (
        <>
            <Grid item xs={4}>
                <FormControlLabel
                    checked={request.changeType}
                    control={<Checkbox />}
                    label="Type"
                    onChange={(e, value) => {
                        updateRequest({
                            ...request,
                            changeType: value
                        })
                    }}
                />
            </Grid>

            {request.changeType &&
                <>
                    <Grid item xs>
                        <TextField
                            variant="outlined"
                            label="Ticket typology"
                            fullWidth
                            select
                            value={request.type}
                            onChange={(e) => updateRequest({
                                ...request,
                                type: e.target.value,
                                typeInfo: ticketTypes.getValueByKey(e.target.value, 'id', 'typeInfo'),
                                issueServiceType: ''
                            })}
                        >
                            {ticketTypes.map(type =>
                                <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>
                            )}
                        </TextField>
                    </Grid>
                    <Grid item xs>
                        {request.typeInfo === TypeInfo.Delivery &&
                            <TextField
                                select
                                variant="outlined"
                                label="Issue service type"
                                fullWidth
                                value={request.issueServiceType}
                                onChange={(e) => updateRequest({
                                    ...request,
                                    issueServiceType: e.target.value
                                })}
                            >
                                {issueServiceTypes.map(issue =>
                                    <MenuItem key={issue.key} value={issue.key}>{issue.value}</MenuItem>)
                                }
                            </TextField>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        <Alert severity="warning" title="Attention">
                            <AlertTitle>By changing ticket type some information will be cleared. You can see the old data from the "Activities" tab</AlertTitle>
                        </Alert>
                    </Grid>
                </>
            }
        </>
    )
}

export default TicketTypology;